import { Accordion } from 'ui/surfaces/Accordion'
import { useContentfulResourcesMapped } from '../../stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { RichText } from 'components/vendor/Contentful/richText/RichTextRenderer'
import { Stack } from 'ui/primitives'
import { Heading } from 'ui/typography'

interface Props {
	contentfulKey: string
}

export const QuestionsSection = ({ contentfulKey }: Props) => {
	const pageResources = useContentfulResourcesMapped()
	const data = ResourceUtils(pageResources[contentfulKey]).getResourceGroup()

	return (
		<Stack gap={{ xs: 'md', md: 'lg' }}>
			{data.map(item => {
				if (item.key === `${contentfulKey}.title`) {
					return <Heading.H2 key={item.textValue}>{item.textValue}</Heading.H2>
				} else {
					return (
						<Accordion key={item.textValue} title={item.textValue!}>
							{item.richTextValue && <RichText document={item.richTextValue} />}
						</Accordion>
					)
				}
			})}
		</Stack>
	)
}
